var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry) {

  pluginRegistry.registerFeature("Octopus.Features.ConfigurationTransforms", function(busy, octopusRepository) {
    return {
      title: "Configuration transforms",
      description: "Runs configuration file transforms, such as _Web.Release.config_",
      editTemplateUrl: "areas/projects/features/Octopus.Features.ConfigurationTransforms_edit.html",
      priority: 21,
      editLink: function($scope, element) {
      },
      enable: function(action, step) {
        action.Properties["Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles"] = "True";
      },
      disable: function(action, step) {
        delete action.Properties["Octopus.Action.Package.AutomaticallyRunConfigurationTransformationFiles"];
        delete action.Properties["Octopus.Action.Package.AdditionalXmlConfigurationTransforms"];
      }
    };
  });

});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/features/Octopus.Features.ConfigurationTransforms.js
// module id = 556
// module chunks = 1